import React from "react"

const Featuring = () => {
  return (
    <div className="featuring">
      <div className="content">
        <h2>Featuring</h2>
        <div className="inline-block text-center padding-right-small">
          {/* <p>
            Jane Fonda | Melissa McCarthy | Gloria Steinem | Tig Notaro | Debbie
            Allen | Margaret Atwood | Paul Reiser | Jodie Turner-Smith | Sheetal
            Sheth | Christine Lahti | Marjan Naderi | Shaakirah Yasmina | Diana
            Kellogg | BETTY
          </p> */}
          <p>
            Debbie Allen | Margaret Atwood | BETTY | Jane Fonda | Josh Gondelman
            | Diana Kellogg | Christine Lahti | Melissa McCarthy | Marjan Naderi
            | Tig Notaro | Paul Reiser | Sheetal Sheth | Gloria Steinem | Jodie
            Turner-Smith | Shaakirah Yasmina
          </p>
        </div>

        <ul className="list-events">
          <li>
            <h3>
              Honoring Phumzile Mlambo-Ngcuka <br />
            </h3>
            <p>Introduced by Gloria Steinem </p>
          </li>
          <li>
            <h3>Fourth Annual Changemaker Award</h3>
            <p>
              Presented by <br /> Gucci and CHIME FOR CHANGE{" "}
            </p>
            <p>
              2021 Award Recipient Shantel Marekera <br />
              in conversation with Jodie Turner-Smith
            </p>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Featuring
